import React, { useState } from 'react';
import {
  Badge,
  Box,
  Button,
  Heading,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Tr,
  TableContainer,
} from '@chakra-ui/react';
import { CheckIcon, CloseIcon } from '@chakra-ui/icons';
import useCurrentUser from '../hooks/useCurrentUser';
import ChangePasswordModal from '../components/ChangePasswordModal';
import { getApiErrorMessage } from '../utils/apiError';

const ProfilePage = () => {
  const { user, isLoading, error, displayName } = useCurrentUser();
  const [isChangePasswordModalOpen, setIsChangePasswordModalOpen] =
    useState(false);

  if (isLoading) {
    return (
      <Box
        w="100%"
        h="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Spinner />
      </Box>
    );
  }

  if (error || !user) {
    return (
      <Box w="100%" display="flex" justifyContent="center" p={5}>
        <Text>
          An error occurred while loading your profile
          {error ? `: ${getApiErrorMessage(error)}` : '.'}
        </Text>
      </Box>
    );
  }

  // Backend sürümüne göre alan adları değişebiliyor (enabled / isEnabled).
  const isEnabled = user.enabled ?? user.isEnabled ?? false;

  const rows = [
    { label: 'Email', value: user.email },
    { label: 'User Name', value: user.userName },
    { label: 'Full Name', value: user.fullName },
    { label: 'Group', value: user.role },
    { label: 'Job Title', value: user.jobTitle },
    { label: 'Description', value: user.description },
    { label: 'Phone Number', value: user.phoneNumber },
  ];

  return (
    <Box w="100%" p={4}>
      <Heading size="lg" mb={4}>
        My Profile
      </Heading>

      <TableContainer
        maxW="600px"
        borderWidth="1px"
        borderColor="gray.200"
        borderRadius="md"
      >
        <Table variant="simple" size="sm">
          <Tbody>
            {rows.map(row => (
              <Tr key={row.label}>
                <Th px={4} py={3} width="200px">
                  {row.label}
                </Th>
                <Td px={4} py={3}>
                  {row.value?.toString().trim() ? row.value : '-'}
                </Td>
              </Tr>
            ))}
            <Tr>
              <Th px={4} py={3} width="200px">
                Status
              </Th>
              <Td px={4} py={3}>
                <Badge
                  colorScheme={isEnabled ? 'green' : 'red'}
                  px={2}
                  py={1}
                  borderRadius="md"
                >
                  {isEnabled ? <CheckIcon mr={1} /> : <CloseIcon mr={1} />}
                  {isEnabled ? 'Enabled' : 'Disabled'}
                </Badge>
              </Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>

      <Button
        mt={4}
        colorScheme="blue"
        onClick={() => setIsChangePasswordModalOpen(true)}
      >
        Change Password
      </Button>

      <ChangePasswordModal
        isOpen={isChangePasswordModalOpen}
        onClose={() => setIsChangePasswordModalOpen(false)}
        userId={user.id}
        userName={displayName}
      />
    </Box>
  );
};

export default ProfilePage;
